<template>
  <v-container
    class="pa-0 mt-1 d-flex align-start"
    :style="{ maxWidth: maxWidth + 'px' }"
  >
    <v-card
      class="rounded-lg"
      width="100%"
      :height="$vuetify.breakpoint.height - 100 + 'px'"
      :loading="loading"
    >
      <v-card-title class="primary white--text pa-1">
        <v-btn icon dark to="/">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="ml-2"
          >Sessions {{ moment(this.time).format("ddd, MMM Do") }}</span
        >        
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"          
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon dark v-bind="attrs" v-on="on" class="ml-2">mdi-calendar-month</v-icon>
          </template>
          <v-date-picker
            ref="picker"
            v-model="time"            
            min="2020-11-15"
            @change="menu = false"        
          ></v-date-picker>
        </v-menu>
        <v-spacer></v-spacer>
        <Header />
      </v-card-title>
      <v-card-text class="pa-0 rounded-lg card-relative" :data-time="currentTime">
        <v-list class="pa-0 rounded-lg" v-if="session_data.length">
          <template v-for="session in session_data">
            <v-list-item :key="session.id" class="pr-0">
              <v-list-item-action style="min-width:150px;">
                <span>{{ getTimeSlot(session) }}</span>
              </v-list-item-action>
              <v-divider vertical></v-divider>
              <v-list-item-content class="py-0">
                <v-list dense class="py-0  rounded-lg">
                  <template v-for="session_row in session.sessions[0]">
                    <v-list-item :key="session_row.id">
                      <v-list-item-content>
                        <div>
                        <v-btn v-if="isInBetween(session_row)" class="text-capitalize" depressed small width="85" color="primary" :to="'/session/' + session_row.session_id" >Join</v-btn>
                        <v-btn v-if="isUpcoming(session_row)" class="text-capitalize" depressed small width="85" color="primary" disabled >Upcoming</v-btn>
                        <v-btn v-if="isCompleted(session_row) && !session_row.pre_recorded_video" class="text-capitalize" depressed small width="85" color="primary" disabled >Completed</v-btn>
                        <v-btn v-if="isCompleted(session_row) && session_row.pre_recorded_video" @click="openVideo(session_row.pre_recorded_video)" class="text-capitalize" depressed small width="85" color="primary">View</v-btn>
                          <span class="ml-2">
                            {{ session_row.title }}
                          </span>
                          <div
                            class="float-right d-flex align-center pt-1 justify-xl-space-between"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  @click="addAgenda(session_row.session_id)"
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    isCompleted(session_row)
                                  "
                                >
                                  <v-icon>mdi-calendar-clock</v-icon>
                                </v-btn>
                              </template>
                              <span>Add to My Itinerary</span>
                            </v-tooltip>
                            <v-tooltip bottom max-width="300">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon>mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ session_row.description }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  @click="addToteBag(session_row.session_id)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon>mdi-briefcase-plus-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Add to my tote bag</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      :key="session_row.id"
                      v-if="
                        session.sessions[0][session.sessions[0].length - 1] !=
                          session_row
                      "
                    ></v-divider>
                  </template>
                </v-list>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="session.id"></v-divider>
          </template>
        </v-list>
        <v-list class="pa-0 rounded-lg" v-else>
          <v-list-item>
            <v-list-content>
              No sessions on {{moment(this.time).format("ddd, MMM Do")}}
            </v-list-content>
          </v-list-item>          
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog v-model="show_preview" max-width="50%">
      <v-card>
        <v-card-text class="pt-2 rounded-lg px-0 py-0">
          <video :src="preview_data" width="100%" v-if="preview_data" autoplay controls controlsList="nodownload"></video>
        </v-card-text>
        <v-btn style="position:absolute;top:0px;right:10px" color="red" dark fab small @click="show_preview = false">          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
  </v-dialog>
  </v-container>
</template>
<script>
import axios from "@/helper/axios";
import { mapState, mapMutations, mapActions } from "vuex";
import Header from "@/components/afterAuth/Header.vue";
export default {
  name: "SessionList",
  components: {
    Header,
  },
  data() {
    return {
      time: this.moment().format('YYYY-MM-DD'),
      menu : false,
      session_data: [],
      loading : false,
      preview_data: null,
      show_preview: false,
      currentTime : new Date()
    };
  },
  computed: {
    ...mapState("utils", ["maxWidth", "pageBackgroundImage"]),   
  },
  watch :{
    time : function(){
      this.getSessions()
    },
    show_preview : function(value){
      if(!value){
       this.preview_data = null
      }
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert", "setBackground"]),
    ...mapActions("agenda", ["fetchAgenda"]),
    ...mapMutations("agenda", ["setAgendaData"]),
    addAgenda(session_id) {
      let _self = this;
      this.loading = "secondary";
      axios
        .post(`agenda/add`, { session_id: session_id })
        .then((response) => {
          let response_data = response.data;
          if (response_data.status) {
            this.fetchAgenda();
            _self.setAlert({
              show: true,
              variant: "success",
              message: response_data.message,
              dismissCountDown: 5000,
            });
          } else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.setAlert({
                show: true,
                variant: "danger",
                message: errors[key].message,
                dismissCountDown: 5000,
              });
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    addToteBag(session_id) {
      let _self = this;
      this.loading = "secondary";
      axios
        .post(`tote_bag/add`, { content_id: session_id, content_type: 1 })
        .then((response) => {
          let response_data = response.data;
          if (response_data.status) {
            _self.setAlert({
              show: true,
              variant: "success",
              message: response_data.message,
              dismissCountDown: 5000,
            });
          } else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.setAlert({
                show: true,
                variant: "danger",
                message: errors[key].message,
                dismissCountDown: 5000,
              });
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    isCompleted(session) {
      let endTime = this.moment(session.end_time);
      let currentTime = this.moment();
      return endTime.diff(currentTime, "seconds") < 0;
    },
    isInBetween(session){
      let startTime = this.moment(session.start_time);
      let endTime = this.moment(session.end_time);
      let currentTime = this.moment();
      return (
        currentTime.isBetween(startTime, endTime)
      );
    },
    isUpcoming(session) {
      let startTime = this.moment(session.start_time);
      let endTime = this.moment(session.end_time);
      let currentTime = this.moment();
      return (
        !currentTime.isBetween(startTime, endTime) && !this.isCompleted(session)
      );
    },
    getTimeSlot(session) {
      return (
        this.moment(session.start_time).format("h:mm a") +
        " - " +
        this.moment(session.end_time).format("h:mm a")
      );
    },
    getSessions() {
      this.loading = 'secondary'
      axios.get("/session/list?time=" + new Date(this.time))
      .then((data) => {
        if (data.data.data) {
          this.session_data = data.data.data;
        }
      })
      .then(()=>{
        this.loading = false
      });
    },
    openVideo(url){
      this.show_preview = true;
      this.preview_data = url;
    },
  },
  mounted: function() {
    this.getSessions();
    this.setBackground({
      image:
        'url("' + process.env.VUE_APP_ASSETS + 'auditorium_background.png")',
    });
    setInterval(()=>{
      this.currentTime = new Date()
    },1000)
  },
  destroyed() {
    this.setBackground({
      image: "",
    });
  },
};
</script>
<style>
.card-relative {
  position: relative;
  top: -5px;
}
</style>
